import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight } from "lucide-react";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const NavRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x1}px;
`;

const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.x1}px;
  color: ${colors.text};
  background: transparent;
  border: none;
  border-radius: ${borderRadius.regular}px;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;

  &:hover:not(:disabled) {
    color: ${colors.primary};
    background: ${colors.backgroundDark};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const MonthLabel = styled.span`
  padding: ${spacing.x1}px ${spacing.x2}px;
  font-size: ${fontSizes.regular}px;
  color: ${colors.text};
  white-space: nowrap;
`;

interface TopListMonthSelectorProps {
  monthLabel: string;
  canGoForward: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const TopListMonthSelector = ({
  monthLabel,
  canGoForward,
  onPrevious,
  onNext,
}: TopListMonthSelectorProps) => {
  const { t } = useTranslation();

  return (
    <NavRow>
      <NavButton
        onClick={onPrevious}
        aria-label={t("statistics.previousPeriod")}
      >
        <ChevronLeft size={20} />
      </NavButton>
      <MonthLabel>{monthLabel}</MonthLabel>
      <NavButton
        onClick={onNext}
        disabled={!canGoForward}
        aria-label={t("statistics.nextPeriod")}
      >
        <ChevronRight size={20} />
      </NavButton>
    </NavRow>
  );
};
